import { render, staticRenderFns } from "./SplitTicketModal.vue?vue&type=template&id=d98f6a38&"
import script from "./SplitTicketModal.vue?vue&type=script&lang=js&"
export * from "./SplitTicketModal.vue?vue&type=script&lang=js&"
import style0 from "./SplitTicketModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports